import React from 'react'
import { useSelector } from "react-redux";

export default function Profile() {
  const userData = useSelector((state) => state.account.userData);
  return (
    <div className="mian-wrap">
      <div className="path-wrap">
        <p className="account-id">
          <span>
            {userData?.username}
            <span className="account-demo">{userData?.name}</span>
          </span>
          <span className="time-zone">GMT+5:30</span>
        </p>
      </div>
      <ul className="menu-list">
        <li className="">
          <a href="/exchange/member/myAccount/detail.jsp" target="_blank">
            My Profile
          </a>
        </li>
        <li className="">
          <a href="/exchange/member/myAccount/summary.jsp" target="_blank">
            Balance Overview
          </a>
        </li>
        <li className="">
          <a href="/current_bets">My Bets</a>
        </li>
        <li className="">
          <a
            href="/exchange/member/myAccount/bet_history.jsp"
            target="_blank"
          >
            Bets History
          </a>
        </li>
        <li className="">
          <a
            href="/exchange/member/myAccount/profit_loss.jsp"
            target="_blank"
          >
            Profit &amp; Loss
          </a>
        </li>
      </ul>
      <a id="logout" className="logout" href="#">
        LOGOUT
      </a>
    </div>
  );
}
